import styled, { css } from 'vue-styled-components';

import { GRAY } from '@styles/common.styled';

export const ComponentWrapper = styled.div`
    width: 100%;
`;

export const BoxWrapper = styled('div', {
    selectedOption: String | Number | Array,
    disabled: Boolean,
    uiDisabled: Boolean,
    maxWidth: String | Number,
})`
    width: 100%;
    height: 34px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border: 1px solid ${GRAY(30)};
    border-radius: 2px;
    font-size: 13px;
    color: ${GRAY(100)};
    padding: 7px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    background-color: ${({ disabled, uiDisabled }) =>
        disabled || uiDisabled ? GRAY(20) : '#fff'};

    svg {
        width: 16px;
        height: 16px;
    }

    h1 {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        ${({ selectedOption }) =>
            (selectedOption ?? '') === '' &&
            css`
                color: ${GRAY(40)};
            `}
        ${({ maxWidth }) =>
            maxWidth &&
            css`
                max-width: ${maxWidth}px;
            `}
    }

    .arrow-icon {
        transition: all 0.2s;

        &.is-open {
            transform: rotate(180deg);
        }
    }
`;
